import { U21Chip } from 'app/shared/u21-ui/components/display/U21Chip';

export const U21NewFeatureLabel = () => {
  return (
    <U21Chip color="info" rounded>
      New
    </U21Chip>
  );
};
